import { Value } from "PFTypes";

import { ExportCategories, ExportFilterGroups, ScheduleFrequency } from "./export_analytics";

type TemplateGroupBy = "category";

export type Template = {
  id: number;
  name: string;
  fields: ExportCategories;
  filters: ExportFilterGroups<Value>;
  createdAt: Date;
  reportsUsing: number;
  reportType: string;
  groupBy: TemplateGroupBy | null;
  aggregateBy: string;
};

export type Schedule = {
  id: number;
  period: string;
  periodDetails?: string;
  nextRun: string;
  templateId: number;
  repeat: ScheduleFrequency;
  repeatDetails: string;
};

type Uri = {
  downloadUri: string;
  createdAt: string;
};

export enum ReportStatus {
  Cancelled = "cancelled",
  InProgress = "in_progress",
  Finished = "finished"
}

export type Report = {
  id: number;
  name: string;
  schedule?: Schedule;
  template: Template;
  status?: ReportStatus;
  versions: Uri[];
};
